<template>
  <div class="p-3 border rounded mt-2 " style="background: #eee;">
    <div v-if="editor" class="mb-2">
      <button
        class="btn btn-sm btn-dark mr-1"
        @click="
          editor
            .chain()
            .focus()
            .toggleHeading({ level: 2 })
            .run()
        "
        :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
      >
        h2
      </button>
      <button
        class="btn btn-sm btn-dark mr-1"
        @click="
          editor
            .chain()
            .focus()
            .toggleHeading({ level: 3 })
            .run()
        "
        :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
      >
        h3
      </button>
      <span class="mr-1">|</span>
      <button
        class="btn btn-sm btn-dark mr-1"
        @click="
          editor
            .chain()
            .focus()
            .toggleBold()
            .run()
        "
        :class="{ 'is-active': editor.isActive('bold') }"
      >
        <font-awesome-icon icon="bold" />
      </button>
      <button
        class="btn btn-sm btn-dark mr-1"
        @click="
          editor
            .chain()
            .focus()
            .toggleItalic()
            .run()
        "
        :class="{ 'is-active': editor.isActive('italic') }"
      >
        <font-awesome-icon icon="italic" />
      </button>
      <button
        class="btn btn-sm btn-dark mr-1"
        @click="
          editor
            .chain()
            .focus()
            .toggleStrike()
            .run()
        "
        :class="{ 'is-active': editor.isActive('strike') }"
      >
        <font-awesome-icon icon="strikethrough" />
      </button>
      <span class="mr-1">|</span>
      <button
        class="btn btn-sm btn-dark mr-1"
        @click="
          editor
            .chain()
            .focus()
            .toggleBulletList()
            .run()
        "
        :class="{ 'is-active': editor.isActive('bulletList') }"
      >
        <font-awesome-icon icon="list-ul" />
      </button>
    </div>
    <editor-content :editor="editor" class="p-2 border bg-white" />
  </div>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";

export default {
  components: {
    EditorContent,
  },
  props: ["richdata"],
  data() {
    return {
      editor: null,
    };
  },

  mounted() {
    this.editor = new Editor({
      content: this.richdata,
      extensions: [StarterKit],
      autofocus: false,
      editable: true,

      onUpdate: () => {
        const html = this.editor.getHTML();
        this.$emit("htmlChange", html);
      },
    });
  },

  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>
